export default "__VITE_ASSET__QuZUXu3x__"